module.exports = __webpack_public_path__ + "static/media/taskit_logo_blanco_web.44e3abc1.png";